<template>
  <a-range-picker :size="size" :value="value" valueFormat="YYYY-MM-DD" 
    @openChange="(flag) => openFlag = flag" :open="openFlag" @change="onChange" 
    :allowClear="allowClear || false" :disabled-date="disabledDate"
  >
    <template slot="renderExtraFooter">
      <slot name="tagLabel"></slot>
      <template  v-for="(val, key) in $enum.TIME_SELECTOR">
        <a-checkable-tag :checked="timeSelector === key" @change="handleTimeTagChange(key)" :key="key" v-if="key !== 'T_DAY' || !tdDisabled">
          {{ val }}
        </a-checkable-tag>
      </template>
    </template>
  </a-range-picker>
</template>
<script>
import moment from 'moment';

export default {
	name: 'TagDateRange',
  props: {
    value: Array,
    getList: Function,
    timeSelector: String,
    size: String,
    allowClear: Boolean,
    // 是否截断今天
    tdDisabled: Boolean
  },
  data() {
		return {
      openFlag: false,
    }
  },
  methods: {
		disabledDate(current) {
      return current && current > (moment().endOf('day') - (this.tdDisabled?24*3600*1000:0));
    },
		handleTimeTagChange(val) {
      val = this.timeSelector === val?'':val
      let value = []
      switch (val) {
        case 'T_DAY':
          value = [moment(), moment()]
          break;
        case 'Y_DAY':
          value = [moment().subtract(1, 'days'), moment().subtract(1, 'days')]
          break;
        case 'DBY_DAY':
          value = [moment().subtract(2, 'days'), moment().subtract(2, 'days')]
          break;
        case 'L_SEVEN_DAY':
          value = [moment().subtract(7, 'days'), moment().subtract(1, 'days')]
          break;
        case 'L_TWO_WEEK':
          value = [moment().subtract(14, 'days'), moment().subtract(1, 'days')]
          break;
        case 'MONTH':
          value = [moment().startOf('month'), this.tdDisabled?moment().subtract(1, 'days'):moment()]
          break;
        case 'L_MONTH':
          value = [moment().subtract(1, 'months').startOf('month'), moment().subtract(1, 'months').endOf('month')]
          break;
        default:
          value = this.value
          break;
      }
      value = value[0].format?[value[0].format('YYYY-MM-DD'), value[1].format('YYYY-MM-DD')]:value
      this.$emit('input', value)
      this.$emit('change', value, val)
      if(val) {
        this.openFlag = false
      }
			this.getList&&this.getList();
    },
		onChange(val) {
      this.$emit('input', val)
      this.$emit('change', val)
			this.getList&&this.getList();
    },
  }
}
</script>